<template>
  <div class="header">
    <div class="container-fluid">
      <!-- Header Section -->
      <div class="mt-4">
        <div class="card">
          <div class="card-body">
            <nav aria-label="breadcrumb">
              <ol class="breadcrumb">
                <li class="breadcrumb-item fw-bolder">Historical Log</li>
              </ol>
            </nav>
          </div>
        </div>
      </div>

      <!-- Table Section -->
      <div class="card mt-5">
        <div class="card-header d-flex justify-content-between align-items-center">
          <h4 class="card-header-title">Historical Log List</h4>
        </div>
        <div class="card-body row">
          <div class="row">
            <div class="form-group col-3 align-items-start pl-0">
              <label>Department</label>
              <!-- {{ listFundCenter }}/ -->
              <v-select
                :options="listDepartment"
                v-model="body.fund_center_id"
                :reduce="(e) => e.value"
                placeholder="Select/Type Here..."
                class="w-md-auto"
                @input="selectFundCenter"
              />
            </div>
            <div class="form-group col-5 align-items-start pl-0">
              <label>Feature</label>
              <!-- {{ listFundCenter }}/ -->
              <v-select
                :options="modules"
                v-model="body.fitur"
                :reduce="(e) => e.value"
                placeholder="Select/Type Here..."
                class="w-md-auto"
                @input="selectModules"
              />
            </div>
            <div class="form-group col-3 align-items-start pl-0">
              <label>Event</label>
              <!-- {{ listFundCenter }}/ -->
              <v-select
                :options="events"
                v-model="body.event"
                :reduce="(e) => e.value"
                placeholder="Select/Type Here..."
                class="w-md-auto"
                @input="selectEvents"
              />
            </div>
          </div>
          <div class="row">
            <div class="form-group col-3 align-items-start pl-0">
              <label>Actor</label>
              <!-- {{ listFundCenter }}/ -->
              <v-select
                :options="actors"
                v-model="body.actor"
                :reduce="(e) => e.value"
                placeholder="Select/Type Here..."
                class="w-md-auto"
                @input="selectActors"
              />
            </div>
            <div class="form-group col-5 align-items-start pl-0">
              <label>Date Range</label>
              <!-- {{ listFundCenter }}/ -->
              <div style="display: flex; flex-direction: column; align-items: flex-start; width: 100%">
                <div class="row ml-1">
                  <div class="form-group col-6 align-items-start pl-0">
                    <date-picker class="w-100 border-0" valueType="format" v-model="formFilter.dateFrom" @input="selectDateFrom" />
                  </div>
                  <div class="form-group col-6 align-items-start pl-0">
                    <date-picker class="w-100 border-0" valueType="format" v-model="formFilter.dateTo" @input="selectDateTo" />
                  </div>
                </div>
              </div>
            </div>
            <div class="form-group col-3 align-items-start pl-0 mt-4">
              <b-button class="btn mr-1" variant="primary" @click="resetForm()"> Reset </b-button>
              <b-button class="btn" variant="primary" @click="getList()"> Filter </b-button>
            </div>
          </div>

          <!--
            <div class="col-md-3 offset-md-9">
            <b-input v-model="body.search" class="mb-3" placeholder="Type Here..." @change="fetchLogs()" />
          </div>
          -->
          <div class="col-12" style="overflow-x: auto">
            <vue-good-table
              :line-numbers="true"
              :columns="fields"
              :rows="logs"
              :total-rows="totalItems"
              :pagination-options="paginationOptions"
              style-class="vgt-table border-0 table"
              @on-page-change="onPageChange"
              @on-per-page-change="onPageChange"
              @on-sort-change="onSortChange"
            >
              <template v-slot:table-row="props">
                <span v-if="props.column.field === 'created_at'">
                  <span>{{ formatDate(props.row.created_at) }}</span>
                </span>
                <span v-else-if="props.column.field === 'module'">
                  <span>{{ translateFeature(props.row.feature) }}</span>
                </span>
                <span v-else-if="props.column.field === 'action'">
                  <b-button size="sm" variant="info" @click="showDetail(props.row)">
                    <span class="fe fe-eye"></span>
                  </b-button>
                </span>
              </template>

              <!-- Custom Pagination -->
              <template slot="pagination-bottom" slot-scope="props">
                <div class="d-flex justify-content-end">
                  <div>
                    <b-pagination
                      :value="currentPage"
                      :total-rows="totalItems"
                      :per-page="body.limit"
                      first-number
                      last-number
                      align="right"
                      prev-class="prev-item"
                      next-class="next-item"
                      class="mr-3 mb-4 mt-0"
                      @input="(value) => props.pageChanged({ currentPage: value })"
                    ></b-pagination>
                  </div>
                </div>
              </template>
            </vue-good-table>
          </div>
        </div>
      </div>
    </div>

    <!-- Panggil Komponen Modal -->
    <DetailActual :logId="Number(selectedLog.id)" :activity="selectedLog.activity" />
    <!-- <DetailModal v-if="isModalOpen" :showModal="isModalOpen" :detail="selectedLog" @update:showModal="isModalOpen = $event" /> -->
    <DetailRelocatemodal
      v-if="isModalOpenRelocate"
      :showModal="isModalOpenRelocate"
      :detail="selectedLog"
      @update:showModal="isModalOpenRelocate = $event"
    />
    <DetailPaymentmodal :logId="Number(selectedLog.id)" :activity="selectedLog.activity" />
    <DetailBudgetTask :logId="Number(selectedLog.id)" :activity="selectedLog.activity" />
    <DetailBudgetPlan :logId="Number(selectedLog.id)" :activity="selectedLog.activity" />
    <DetailInternalMemo :logId="Number(selectedLog.id)" :activity="selectedLog.activity" />
    <DetailMasterData :logId="Number(selectedLog.id)" :activity="selectedLog.activity" :modules="selectedLog.feature" />
    <DetailRole :logId="Number(selectedLog.id)" :activity="selectedLog.activity" :modules="selectedLog.feature" />
  </div>
</template>

<script>
import moment from 'moment';
import axiosIns from '@/api/axios';
import DetailModal from './DetailModal.vue';
import DetailRelocatemodal from './DetailRelocatemodal.vue';
import DetailPaymentmodal from './DetailPaymentmodal.vue';
import DetailActual from './DetailActual.vue';
import DetailBudgetTask from './DetailBudgetTask.vue';
import DetailBudgetPlan from './DetailBudgetPlan.vue';
import DetailInternalMemo from '@/views/historicalLog/DetailInternalMemo.vue';
import DetailMasterData from '@/views/historicalLog/DetailMasterData.vue';
import DetailRole from '@/views/historicalLog/DetailMasterDataRole.vue';

export default {
  components: {
    DetailRole,
    DetailMasterData,
    DetailInternalMemo,
    DetailModal,
    DetailRelocatemodal,
    DetailPaymentmodal,
    DetailActual,
    DetailBudgetTask,
    DetailBudgetPlan,
  },
  data() {
    return {
      formFilter: {
        department: '',
        event: '',
        fitur: '',
        actor: '',
        dateFrom: '',
        dateTo: '',
      },

      isModalOpen: false,
      isModalOpenRelocate: false,
      isModalOpenPayment: false,
      searchTerm: '',
      selectedLog: {},
      logs: [],
      modules: [],
      events: [],
      actors: [],
      fields: [
        // { label: "ID", field: "id", sortable: true },
        { label: 'Event', field: 'activity', sortable: true },
        { label: 'Scope', field: 'scope', sortable: true },
        { label: 'Activity', field: 'activity_description', sortable: false },
        { label: 'Feature', field: 'module', sortable: true },
        { label: 'Actor', field: 'createdUser', sortable: true },
        { label: 'Created At', field: 'created_at', sortable: true },
        { label: 'Action', field: 'action' },
      ],
      paginationOptions: {
        enabled: true,
        perPage: 10,
      },
      totalItems: 0,
      currentPage: 1,
      limit: 10,
      body: {
        page: 1,
        limit: 10,
        field: null,
        order: null,
        search: null,
        department: null,
        event: null,
        fitur: null,
        actor: null,
        dateFrom: null,
        dateTo: null,
      },
    };
  },
  async mounted() {
    await this.getListDepartment().then(() => {
      if (this.listDepartment.length > 0) {
        const selectedDepartment = this.listDepartment.find((e) => e.row?.department_code === this.activePlan?.fund_center?.department_code);
        this.body.fund_center_id = selectedDepartment?.value;
        this.isLoading = true;
        this.body.dept = selectedDepartment?.value;
        this.selectedDepartment = selectedDepartment?.value;
        this.$store.dispatch('budgetPlan/SET_SELECTED_FUND_CENTER', selectedDepartment?.value);
      }
    });
    this.fetchLogs();
    this.fetchModule();
    this.fetchEvents();
    this.fetchActors();
  },
  computed: {
    listDepartment() {
      return this.$store.getters['budgetPlan/listDepartment']
        .sort((a, b) => a.department_code.localeCompare(b.department_code)) // ASC sort
        .map((items) => ({
          label: `${items.department_code} - ${items.organization}`,
          value: items.id,
          row: items,
        }));
    },
  },
  methods: {
    getList() {
      axiosIns
        .get('/historical-log', {
          params: {
            page: this.body.page,
            limit: this.body.limit,
            field: this.body.field,
            order: this.body.order,
            search: this.body.search,
            department: this.body.department,
            fitur: this.body.fitur,
            event: this.body.event,
            actor: this.body.actor,
            dateFrom: this.body.dateFrom,
            dateTo: this.body.dateTo,
          },
        })
        .then((response) => {
          this.logs = response.data.data.data; // Ambil data dari response.data.data.data
          this.totalItems = response.data.data.totalItems; // Ambil totalItems
        })
        .catch((error) => {
          console.error('Error fetching logs:', error);
        });
    },
    resetForm() {
      this.body = {
        pageNumber: 1,
        pageSize: 10,
        search: '',
        department: '',
        field: '',
        order: '',
        fitur: '',
        event: '',
        actor: '',
        dateFrom: '',
        dateTo: '',
      };
      this.getList();
    },
    fetchActors() {
      axiosIns
        .get('/historical-log/actors')
        .then((response) => {
          this.actors = response.data.data;
        })
        .catch((error) => {
          console.error('Error fetching logs:', error);
        });
    },
    fetchEvents() {
      axiosIns
        .get('/historical-log/events')
        .then((response) => {
          this.events = response.data.data;
        })
        .catch((error) => {
          console.error('Error fetching logs:', error);
        });
    },
    fetchModule() {
      axiosIns
        .get('/historical-log/modules')
        .then((response) => {
          this.modules = response.data?.data.map((item) => {
            return {
              ...item,
              label: this.translateFeature(item.feature),
            };
          });
        })
        .catch((error) => {
          console.error('Error fetching logs:', error);
        });
    },
    selectFundCenter(value) {
      if (value === null) {
        this.isLoading = true;
        this.body.department = '';
        //this.getList();
        axiosIns
          .get('/historical-log', {
            params: {
              page: this.body.page,
              limit: this.body.limit,
              field: this.body.field,
              order: this.body.order,
              search: this.body.search,
              department: this.body.department,
              fitur: this.body.fitur,
              event: this.body.event,
              actor: this.body.actor,
              dateFrom: this.body.dateFrom,
              dateTo: this.body.dateTo,
            },
          })
          .then((response) => {
            this.logs = response.data.data.data; // Ambil data dari response.data.data.data
            this.totalItems = response.data.data.totalItems; // Ambil totalItems
          })
          .catch((error) => {
            console.error('Error fetching logs:', error);
          });
      } else {
        this.isLoading = true;
        this.body.department = value;
        //this.getList();
        this.selectedDepartment = value;
        axiosIns
          .get('/historical-log', {
            params: {
              page: this.body.page,
              limit: this.body.limit,
              field: this.body.field,
              order: this.body.order,
              search: this.body.search,
              department: this.body.department,
              fitur: this.body.fitur,
              event: this.body.event,
              actor: this.body.actor,
              dateFrom: this.body.dateFrom,
              dateTo: this.body.dateTo,
            },
          })
          .then((response) => {
            this.logs = response.data.data.data; // Ambil data dari response.data.data.data
            this.totalItems = response.data.data.totalItems; // Ambil totalItems
          })
          .catch((error) => {
            console.error('Error fetching logs:', error);
          });
      }
      this.$store.dispatch('budgetPlan/SET_SELECTED_FUND_CENTER', value);
    },
    selectModules(value) {
      if (value === null) {
        this.isLoading = true;
        this.body.fitur = '';
        //this.getList();
        axiosIns
          .get('/historical-log', {
            params: {
              page: this.body.page,
              limit: this.body.limit,
              field: this.body.field,
              order: this.body.order,
              search: this.body.search,
              department: this.body.department,
              fitur: this.body.fitur,
              event: this.body.event,
              actor: this.body.actor,
              dateFrom: this.body.dateFrom,
              dateTo: this.body.dateTo,
            },
          })
          .then((response) => {
            this.logs = response.data.data.data; // Ambil data dari response.data.data.data
            this.totalItems = response.data.data.totalItems; // Ambil totalItems
          })
          .catch((error) => {
            console.error('Error fetching logs:', error);
          });
      } else {
        this.isLoading = true;
        this.body.fitur = value;
        //this.getList();
        //this.selectedDepartment = value;
        axiosIns
          .get('/historical-log', {
            params: {
              page: this.body.page,
              limit: this.body.limit,
              field: this.body.field,
              order: this.body.order,
              search: this.body.search,
              department: this.body.department,
              fitur: this.body.fitur,
              event: this.body.event,
              actor: this.body.actor,
              dateFrom: this.body.dateFrom,
              dateTo: this.body.dateTo,
            },
          })
          .then((response) => {
            this.logs = response.data.data.data; // Ambil data dari response.data.data.data
            this.totalItems = response.data.data.totalItems; // Ambil totalItems
          })
          .catch((error) => {
            console.error('Error fetching logs:', error);
          });
      }
      //this.$store.dispatch('budgetPlan/SET_SELECTED_FUND_CENTER', value);
    },
    selectEvents(value) {
      if (value === null) {
        this.isLoading = true;
        this.body.event = '';
        axiosIns
          .get('/historical-log', {
            params: {
              page: this.body.page,
              limit: this.body.limit,
              field: this.body.field,
              order: this.body.order,
              search: this.body.search,
              department: this.body.department,
              fitur: this.body.fitur,
              event: this.body.event,
              actor: this.body.actor,
              dateFrom: this.body.dateFrom,
              dateTo: this.body.dateTo,
            },
          })
          .then((response) => {
            this.logs = response.data.data.data; // Ambil data dari response.data.data.data
            this.totalItems = response.data.data.totalItems; // Ambil totalItems
          })
          .catch((error) => {
            console.error('Error fetching logs:', error);
          });
      } else {
        this.isLoading = true;
        this.body.event = value;
        axiosIns
          .get('/historical-log', {
            params: {
              page: this.body.page,
              limit: this.body.limit,
              field: this.body.field,
              order: this.body.order,
              search: this.body.search,
              department: this.body.department,
              fitur: this.body.fitur,
              event: this.body.event,
              actor: this.body.actor,
              dateFrom: this.body.dateFrom,
              dateTo: this.body.dateTo,
            },
          })
          .then((response) => {
            this.logs = response.data.data.data;
            this.totalItems = response.data.data.totalItems;
          })
          .catch((error) => {
            console.error('Error fetching logs:', error);
          });
      }
      //this.$store.dispatch('budgetPlan/SET_SELECTED_FUND_CENTER', value);
    },
    selectActors(value) {
      if (value === null) {
        this.isLoading = true;
        this.body.actor = '';
        axiosIns
          .get('/historical-log', {
            params: {
              page: this.body.page,
              limit: this.body.limit,
              field: this.body.field,
              order: this.body.order,
              search: this.body.search,
              department: this.body.department,
              fitur: this.body.fitur,
              event: this.body.event,
              actor: this.body.actor,
              dateFrom: this.body.dateFrom,
              dateTo: this.body.dateTo,
            },
          })
          .then((response) => {
            this.logs = response.data.data.data; // Ambil data dari response.data.data.data
            this.totalItems = response.data.data.totalItems; // Ambil totalItems
          })
          .catch((error) => {
            console.error('Error fetching logs:', error);
          });
      } else {
        this.isLoading = true;
        this.body.actor = value;
        axiosIns
          .get('/historical-log', {
            params: {
              page: this.body.page,
              limit: this.body.limit,
              field: this.body.field,
              order: this.body.order,
              search: this.body.search,
              department: this.body.department,
              fitur: this.body.fitur,
              event: this.body.event,
              actor: this.body.actor,
              dateFrom: this.body.dateFrom,
              dateTo: this.body.dateTo,
            },
          })
          .then((response) => {
            this.logs = response.data.data.data;
            this.totalItems = response.data.data.totalItems;
          })
          .catch((error) => {
            console.error('Error fetching logs:', error);
          });
      }
      //this.$store.dispatch('budgetPlan/SET_SELECTED_FUND_CENTER', value);
    },
    selectDateFrom(value) {
      if (value === null) {
        this.isLoading = true;
        this.body.dateFrom = '';
        axiosIns
          .get('/historical-log', {
            params: {
              page: this.body.page,
              limit: this.body.limit,
              field: this.body.field,
              order: this.body.order,
              search: this.body.search,
              department: this.body.department,
              fitur: this.body.fitur,
              event: this.body.event,
              actor: this.body.actor,
              dateFrom: this.body.dateFrom,
              dateTo: this.body.dateTo,
            },
          })
          .then((response) => {
            this.logs = response.data.data.data; // Ambil data dari response.data.data.data
            this.totalItems = response.data.data.totalItems; // Ambil totalItems
          })
          .catch((error) => {
            console.error('Error fetching logs:', error);
          });
      } else {
        this.isLoading = true;
        this.body.dateFrom = value;
        axiosIns
          .get('/historical-log', {
            params: {
              page: this.body.page,
              limit: this.body.limit,
              field: this.body.field,
              order: this.body.order,
              search: this.body.search,
              department: this.body.department,
              fitur: this.body.fitur,
              event: this.body.event,
              actor: this.body.actor,
              dateFrom: this.body.dateFrom,
              dateTo: this.body.dateTo,
            },
          })
          .then((response) => {
            this.logs = response.data.data.data;
            this.totalItems = response.data.data.totalItems;
          })
          .catch((error) => {
            console.error('Error fetching logs:', error);
          });
      }
      //this.$store.dispatch('budgetPlan/SET_SELECTED_FUND_CENTER', value);
    },
    selectDateTo(value) {
      if (value === null) {
        this.isLoading = true;
        this.body.dateTo = '';
        axiosIns
          .get('/historical-log', {
            params: {
              page: this.body.page,
              limit: this.body.limit,
              field: this.body.field,
              order: this.body.order,
              search: this.body.search,
              department: this.body.department,
              fitur: this.body.fitur,
              event: this.body.event,
              actor: this.body.actor,
              dateFrom: this.body.dateFrom,
              dateTo: this.body.dateTo,
            },
          })
          .then((response) => {
            this.logs = response.data.data.data; // Ambil data dari response.data.data.data
            this.totalItems = response.data.data.totalItems; // Ambil totalItems
          })
          .catch((error) => {
            console.error('Error fetching logs:', error);
          });
      } else {
        this.isLoading = true;
        this.body.dateTo = value;
        axiosIns
          .get('/historical-log', {
            params: {
              page: this.body.page,
              limit: this.body.limit,
              field: this.body.field,
              order: this.body.order,
              search: this.body.search,
              department: this.body.department,
              fitur: this.body.fitur,
              event: this.body.event,
              actor: this.body.actor,
              dateFrom: this.body.dateFrom,
              dateTo: this.body.dateTo,
            },
          })
          .then((response) => {
            this.logs = response.data.data.data;
            this.totalItems = response.data.data.totalItems;
          })
          .catch((error) => {
            console.error('Error fetching logs:', error);
          });
      }
      //this.$store.dispatch('budgetPlan/SET_SELECTED_FUND_CENTER', value);
    },
    getListDataDepartment() {
      this.options = this.listDepartment.map((items) => ({
        name: `${items.row.department_code} - ${items.row.organization}`,
        id: items.row.department_code,
        row: items.row,
      }));
    },
    async getListDepartment() {
      try {
        await this.$store.dispatch('budgetPlan/GET_LIST_DEPARTMENT');
      } catch (error) {
        console.error('Failed to fetch year options:', error);
      }
    },
    fetchLogs() {
      axiosIns
        .get('/historical-log', {
          params: {
            page: this.body.page,
            limit: this.body.limit,
            field: this.body.field,
            order: this.body.order,
            search: this.body.search,
            fitur: this.body.fitur,
            event: this.body.event,
            actor: this.body.actor,
            dateFrom: this.body.dateFrom,
            dateTo: this.body.dateTo,
          },
        })
        .then((response) => {
          this.logs = response.data.data.data; // Ambil data dari response.data.data.data
          this.totalItems = response.data.data.totalItems; // Ambil totalItems
        })
        .catch((error) => {
          console.error('Error fetching logs:', error);
        });
    },
    showDetail(log) {
      this.selectedLog = log;

      /*else if (log.feature === 'budget-relocate') {
        this.isModalOpenRelocate = true;
      }*/
      if (log.feature === 'budget-actual') {
        setTimeout(() => {
          this.$bvModal.show('modal-detail-historical-actual');
        }, 100);
      } else if (log.feature === 'budget-actual-payment') {
        setTimeout(() => {
          this.$bvModal.show('modal-detail-historical-payment');
        }, 100);
      } else if (log.feature === 'budget-task') {
        setTimeout(() => {
          this.$bvModal.show('modal-detail-historical-budget-task');
        }, 100);
      } else if (log.feature === 'budget-plan') {
        setTimeout(() => {
          this.$bvModal.show('modal-detail-historical-plan');
        }, 100);
      } else if (log.feature === 'internal-memo') {
        setTimeout(() => {
          this.$bvModal.show('modal-detail-historical-internal-memo');
        }, 100);
      } else if (
        log.feature === 'fund-center' ||
        log.feature === 'fund' ||
        log.feature === 'transaction-type' ||
        log.feature === 'budget-item' ||
        log.feature === 'opex-gl' ||
        log.feature === 'capex-gl' ||
        log.feature === 'user' ||
        log.feature === 'project-tags' ||
        log.feature === 'organization' ||
        log.feature === 'budget-relocate'
      ) {
        setTimeout(() => {
          this.$bvModal.show('modal-detail-historical-master-data');
        }, 100);
      } else if (log.feature === 'budget-plan') {
        setTimeout(() => {
          this.$bvModal.show('modal-detail-historical-budget-plan');
        }, 100);
      } else if (log.feature === 'role') {
        setTimeout(() => {
          this.$bvModal.show('modal-detail-historical-master-data-role');
        }, 100);
      }
    },
    exportData() {
      console.log('Exporting data...');
    },
    // Pagination Handlers
    onPageChange(payload) {
      this.body.page = payload.currentPage;
      this.body.limit = payload.currentPerPage;
      this.fetchLogs(); // Menyegarkan data setelah halaman berubah
    },
    onSortChange(params) {
      const sort1 = params[0].field;
      const sort2 = params[0].type;
      this.body.field = sort1;
      if (sort2 === 'none') {
        this.body.order = ''; // Reset urutan jika 'none'
      } else {
        this.body.order = sort2; // Menetapkan urutan berdasarkan tipe
      }
      this.fetchLogs(); // Menyegarkan data setelah pengurutan berubah
    },
    formatDate(dateString) {
      return `${moment(dateString).format('DD MMM YYYY HH:mm')} WIB`;
    },
    translateFeature(feature) {
      const featureMap = {
        'budget-actual': 'PR/PO',
        'budget-relocate': 'Budget Relocate',
        'budget-actual-payment': 'Detail Payment',
        'budget-task': 'Budget Task',
        'internal-memo': 'Internal Memo',
        'fund-center': 'Fund Center',
        fund: 'Fund',
        'transaction-type': 'Transaction Type',
        'budget-item': 'Budget Item',
        'opex-gl': 'Opex GL',
        'capex-gl': 'Capex GL',
        user: 'User',
        'project-tags': 'Project Tags',
        organization: 'Department',
        'budget-plan': 'Budget Plan',
        role: 'Role',
      };
      return featureMap[feature] || feature;
    },
  },
};
</script>

<style scoped>
.text-right {
  text-align: right;
}
</style>
